import './index.css';
import DigitalClick from './DigitalClock';

function App() {
  return (<DigitalClick/>);
}

export default App;
